function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RegistrationPageCtrl = /*#__PURE__*/function () {
  RegistrationPageCtrl.$inject = ["$http", "$q", "$timeout", "$translate", "$window", "toaster"];

  /*@ngInject*/
  function RegistrationPageCtrl($http, $q, $timeout, $translate, $window, toaster) {
    _classCallCheck(this, RegistrationPageCtrl);

    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$translate = $translate;
    this.toaster = toaster;
    this.$window = $window;
  }

  _createClass(RegistrationPageCtrl, [{
    key: "submit",
    value: function submit() {
      var _this = this;

      this.checkCaptcha().then(function (result) {
        return _this.$http.post('user/registrationjson', {
          firstName: _this.fname,
          lastname: _this.lastname,
          patronymic: _this.patronymic,
          email: _this.email,
          phone: _this.phone,
          birthday: _this.birthday,
          password: _this.pass,
          passwordConfirm: _this.passagain,
          wantBonusCard: _this.wantBonusCard,
          newsSubscription: _this.subscr,
          agree: _this.agreement,
          customerFields: _this.CustomerFields,
          lpId: _this.lpId
        });
      }).then(function (response) {
        if (response.data.result === true) {
          _this.$window.location.assign(response.data.obj);
        } else {
          return _this.$q.reject(response.data.errors);
        }
      }).catch(function (result) {
        _this.toaster.pop('error', '', Array.isArray(result) ? result.join('<br>') : result);
      });
    }
  }, {
    key: "checkCaptcha",
    value: function checkCaptcha() {
      var _this2 = this;

      if (typeof CaptchaSource != 'undefined') {
        CaptchaSource.InputId = 'CaptchaCode';
        return this.$http.get(CaptchaSource.ValidationUrl + '&i=' + CaptchaSource.GetInputElement().value).then(function (result) {
          _this2.$timeout(function () {
            CaptchaSource.ReloadImage();
          }, 1000);

          CaptchaSource.GetInputElement().value = '';

          if (result.data === true) {
            return _this2.$q.resolve();
          } else {
            return _this2.$q.reject(_this2.$translate.instant('Js.Captcha.Wrong'));
          }
        });
      } else {
        return this.$q.resolve();
      }
    }
  }]);

  return RegistrationPageCtrl;
}();

export default RegistrationPageCtrl;